// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P2-07: PaperTradePanel styles.
 *
 * Uses CSS variables from .vnsc-root for theme inheritance.
 * No hardcoded colors — all values derive from --vnsc-* variables.
 */

.vnsc-paper-trade-panel {
	position: relative;
	height: 100%;
	flex-shrink: 0;
	width: 280px;
	background: var(--vnsc-bg-primary);
	border-left: 1px solid var(--vnsc-border);
	z-index: 50;
	display: flex;
	flex-direction: column;
	font-size: var(--vnsc-font-sm);
	color: var(--vnsc-text-primary);
	overflow: hidden;
}

[data-vnsc-bottom-panel="host"] .vnsc-paper-trade-panel {
	width: 100%;
	border-left: none;
	background: transparent;
}

.vnsc-paper-trade-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border);
	flex-shrink: 0;
}

.vnsc-paper-trade-panel__title {
	font-size: var(--vnsc-font-md);
	font-weight: 700;
}

.vnsc-paper-trade-panel__reset-btn {
	background: var(--vnsc-bg-tertiary);
	border: none;
	color: var(--vnsc-text-secondary);
	border-radius: var(--vnsc-radius-md);
	cursor: pointer;
	padding: 4px 8px;
	font-size: var(--vnsc-font-sm);
	font-weight: 600;
	transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}

.vnsc-paper-trade-panel__reset-btn:hover {
	background: var(--vnsc-border);
	color: var(--vnsc-text-primary);
}

.vnsc-paper-trade-panel__stats {
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border);
	flex-shrink: 0;
}

.vnsc-paper-trade-panel__stats-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 4px;
}

.vnsc-paper-trade-panel__stat-label {
	font-size: var(--vnsc-font-xs);
	color: var(--vnsc-text-secondary);
}

.vnsc-paper-trade-panel__stat-value {
	font-weight: 700;
	font-size: var(--vnsc-font-lg);
}

.vnsc-paper-trade-panel__position {
	padding: 8px 12px;
	border-bottom: 1px solid var(--vnsc-border);
	flex-shrink: 0;
}

.vnsc-paper-trade-panel__position-title {
	font-weight: 700;
	margin-bottom: 4px;
}

.vnsc-paper-trade-panel__position-side {
	display: inline-block;
	padding: 2px 6px;
	border-radius: var(--vnsc-radius-sm);
	font-size: var(--vnsc-font-xs);
	font-weight: 700;
}

.vnsc-paper-trade-panel__position-side--long {
	background: var(--vnsc-up);
	color: #fff;
}

.vnsc-paper-trade-panel__position-side--short {
	background: var(--vnsc-down);
	color: #fff;
}

.vnsc-paper-trade-panel__position-entry {
	margin-top: 4px;
	color: var(--vnsc-text-secondary);
}

.vnsc-paper-trade-panel__position-empty {
	color: var(--vnsc-text-secondary);
}

.vnsc-paper-trade-panel__journal {
	flex: 1;
	overflow-y: auto;
	padding: 8px 12px;
}

.vnsc-paper-trade-panel__journal-title {
	font-weight: 700;
	margin-bottom: 4px;
}

.vnsc-paper-trade-panel__journal-empty {
	color: var(--vnsc-text-secondary);
	text-align: center;
	padding: 16px 0;
}

.vnsc-paper-trade-panel__journal-item {
	display: flex;
	justify-content: space-between;
	padding: 4px 0;
	border-bottom: 1px solid var(--vnsc-border);
}

.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-side {
	color: var(--vnsc-up);
}

.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {
	color: var(--vnsc-up);
}

.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-side {
	color: var(--vnsc-down);
}

.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {
	color: var(--vnsc-down);
}

.vnsc-paper-trade-panel__journal-side {
	font-size: var(--vnsc-font-xs);
	font-weight: 700;
}

.vnsc-paper-trade-panel__journal-pnl {
	font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/paper-trade.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,kCAAkC;CAClC,yCAAyC;CACzC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,iBAAiB;CACjB,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,YAAY;CACZ,iCAAiC;CACjC,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,gBAAgB;CAChB,qFAAqF;AACtF;;AAEA;CACC,8BAA8B;CAC9B,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;CACjB,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,QAAQ;AACT;;AAEA;CACC,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,oCAAoC;CACpC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iCAAiC;AAClC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;CACd,2CAA2C;AAC5C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB","sourcesContent":["/**\r\n * WE2 P2-07: PaperTradePanel styles.\r\n *\r\n * Uses CSS variables from .vnsc-root for theme inheritance.\r\n * No hardcoded colors — all values derive from --vnsc-* variables.\r\n */\r\n\r\n.vnsc-paper-trade-panel {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\tflex-shrink: 0;\r\n\twidth: 280px;\r\n\tbackground: var(--vnsc-bg-primary);\r\n\tborder-left: 1px solid var(--vnsc-border);\r\n\tz-index: 50;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tcolor: var(--vnsc-text-primary);\r\n\toverflow: hidden;\r\n}\r\n\r\n[data-vnsc-bottom-panel=\"host\"] .vnsc-paper-trade-panel {\r\n\twidth: 100%;\r\n\tborder-left: none;\r\n\tbackground: transparent;\r\n}\r\n\r\n.vnsc-paper-trade-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-paper-trade-panel__title {\r\n\tfont-size: var(--vnsc-font-md);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.vnsc-paper-trade-panel__reset-btn {\r\n\tbackground: var(--vnsc-bg-tertiary);\r\n\tborder: none;\r\n\tcolor: var(--vnsc-text-secondary);\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tcursor: pointer;\r\n\tpadding: 4px 8px;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tfont-weight: 600;\r\n\ttransition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\r\n}\r\n\r\n.vnsc-paper-trade-panel__reset-btn:hover {\r\n\tbackground: var(--vnsc-border);\r\n\tcolor: var(--vnsc-text-primary);\r\n}\r\n\r\n.vnsc-paper-trade-panel__stats {\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-paper-trade-panel__stats-grid {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 1fr 1fr;\r\n\tgap: 4px;\r\n}\r\n\r\n.vnsc-paper-trade-panel__stat-label {\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tcolor: var(--vnsc-text-secondary);\r\n}\r\n\r\n.vnsc-paper-trade-panel__stat-value {\r\n\tfont-weight: 700;\r\n\tfont-size: var(--vnsc-font-lg);\r\n}\r\n\r\n.vnsc-paper-trade-panel__position {\r\n\tpadding: 8px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-title {\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-side {\r\n\tdisplay: inline-block;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: var(--vnsc-radius-sm);\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-side--long {\r\n\tbackground: var(--vnsc-up);\r\n\tcolor: #fff;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-side--short {\r\n\tbackground: var(--vnsc-down);\r\n\tcolor: #fff;\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-entry {\r\n\tmargin-top: 4px;\r\n\tcolor: var(--vnsc-text-secondary);\r\n}\r\n\r\n.vnsc-paper-trade-panel__position-empty {\r\n\tcolor: var(--vnsc-text-secondary);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 8px 12px;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-title {\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-empty {\r\n\tcolor: var(--vnsc-text-secondary);\r\n\ttext-align: center;\r\n\tpadding: 16px 0;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tpadding: 4px 0;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-side {\r\n\tcolor: var(--vnsc-up);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {\r\n\tcolor: var(--vnsc-up);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-side {\r\n\tcolor: var(--vnsc-down);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {\r\n\tcolor: var(--vnsc-down);\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-side {\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.vnsc-paper-trade-panel__journal-pnl {\r\n\tfont-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
